"use client";

import appInsights from "@portal/appInsights";
import UserNotification from "@portal/components/molecules/userNotification";
import { SessionProvider } from "@portal/auth/client/SessionProvider";
import { Suspense, useEffect } from "react";
import { addSignOutListner, removeSignOutListner } from "@portal/auth/client/api/signOut/signOutBroadcast";
import useAddDarkModeToHtmlElement from "@portal/hooks/useAddDarkModeToHtmlElement";

if (typeof window !== "undefined") {
  try {
    appInsights.loadAppInsights();
    appInsights.trackPageView();
  } catch (error) {
    console.error("failed loading app insights", error);
  }
}

const InnerLayout = ({ children }: Readonly<{ children: React.ReactNode }>) => {
  useAddDarkModeToHtmlElement();

  useEffect(() => {
    const handleSignOut = () => {
      // handle sign out in a different tab, make it delayed to allow logout process to finish
      setTimeout(() => {
        window.location.href = "/logout";
      }, 3000);
    };

    addSignOutListner(handleSignOut);
    return () => {
      removeSignOutListner(handleSignOut);
    };
  }, []);

  return (
    <>
      <Suspense>{children}</Suspense>
      <UserNotification />
    </>
  );
};

const RootLayout = ({ children }: Readonly<{ children: React.ReactNode }>) => (
  <SessionProvider>
    <InnerLayout>{children}</InnerLayout>
  </SessionProvider>
);

export default RootLayout;
